// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1E-VEU7L5mcPhdPZUd_grK input[type=\"file\"] {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"label": "_1E-VEU7L5mcPhdPZUd_grK"
};
module.exports = exports;
